export default __webpack_public_path__ + "static/media/caio-paes-modal.ab01ad44.jpg";